export abstract class BaseModal {
    protected backdrop: HTMLDivElement;
    protected card: HTMLDivElement;
    protected loadingOverlay: HTMLDivElement;

    constructor() {
        this.backdrop = document.createElement('div');
        this.backdrop.className = 'sl-modal-backdrop';
        this.backdrop.onclick = (e) => {
            if (e.target === this.backdrop) this.destroy();
        };

        this.card = document.createElement('div');
        this.card.className = 'sl-modal-content';
        this.card.onclick = (e) => e.stopPropagation();
        this.backdrop.appendChild(this.card);

        this.loadingOverlay = document.createElement('div');
        this.loadingOverlay.className = 'sl-modal-loading';
        this.loadingOverlay.innerHTML = `<img src="/square.svg" alt="Loading..."/>`;
        this.card.appendChild(this.loadingOverlay);

        this.handleEsc = this.handleEsc.bind(this);
    }

    protected abstract buildDOM(): void;

    public show() {
        document.body.appendChild(this.backdrop);
        this.backdrop.style.display = 'flex';
        document.addEventListener('keydown', this.handleEsc);
    }

    public setLoading(isLoading: boolean) {
        if (this.loadingOverlay) {
            this.loadingOverlay.style.display = isLoading ? 'flex' : 'none';
        }
    }

    protected handleEsc(e: KeyboardEvent) {
        if (e.key === 'Escape') this.destroy();
    }

    public destroy() {
        document.removeEventListener('keydown', this.handleEsc);
        this.backdrop.remove();
    }
}
